module.exports = __webpack_public_path__ + "assets/img/tx102b_1.dc58bf29.jpg";